const lclExportChargesData1 = {
    initialLength: 14,
    preList: [{
            id: 1,
            chargeDescription: 'Pick-up Charges',
            category: 'ORIGIN',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
        },
        {
            id: 2,
            chargeDescription: 'Origin Customs Clearance',
            category: 'ORIGIN',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
            disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 3,
            chargeDescription: 'Origin Charges',
            category: 'ORIGIN',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'INR',
            onaccount: "On Your Account",
        },
        {
            id: 4,
            chargeDescription: 'Origin Inland Haulage',
            category: 'ORIGIN',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'INR',
            onaccount: "On Your Account",
        },
        {
            id: 5,
            chargeDescription: 'Ocean Freight',
            category: 'FREIGHT',
            currency: 'USD',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
        },
        {
            id: 6,
            chargeDescription: 'Hazardous Surcharge',
            category: 'FREIGHT',
            currency: 'USD',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 7,
            chargeDescription: 'Non-Stackable Surcharge',
            category: 'FREIGHT',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'USD',
            onaccount: "On Your Account",
        },
        {
            id: 8,
            chargeDescription: 'Destination Inland Haulage',
            category: 'DESTINATION',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 9,
            chargeDescription: 'Destination Charges',
            category: 'DESTINATION',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 10,
            chargeDescription: 'Destination CFS Charges',
            category: 'DESTINATION',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 11,
            chargeDescription: 'Destination Customs Clearance',
            category: 'DESTINATION',
            currency: '',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 12,
            chargeDescription: 'Delivery Charges',
            category: 'DESTINATION',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },{
            id: 13,
            chargeDescription: 'Terminal Handling Fees',
            category: 'ORIGIN',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },{
            id: 14,
            chargeDescription: 'BL Fees',
            category: 'ORIGIN',
           perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        }
    ], rebate:[
    {
      id: 1,
      category: 'REBATE',
      chargeDescription: 'Rebate',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
      minimum: 0,
      maximum: 0,
    },
    
  ], pkb:[
    {
      id: 1,
      category: 'PKB',
      chargeDescription: 'Freight Commission',
      currency: 'USD',
      perCBM: 0,
      perTon: 0,
      minimum: 0,
      maximum: 0,
    },
  ]
}
export default lclExportChargesData1